import gql from "graphql-tag";

export default gql`query BillTemplatePopulated($id:Int!) {
    billTemplatePopulated(id:$id) {
        id    
        bill(id:$id) {
            id
            payable
            customdate
            unaccounted
            duetag
            heading
            total
            vatrate
            timestamp
            address
            locked 
            special
            tracker
            related {
              id
            }
            file {
                id
                category {
                    id
                    name
                    shortname
                }
                department {
                    id
                }
                referencelong
                subjectProperty
                payments{
                    id
                    amount
                }
                receipts {
                    id
                    amount
                }
            }
        }
        templateMonies {
          id
          name
          paidreceived
          money(id:$id) {
            id
            vat
            total
          }
          templateSections {
            id
            name
            vat
            nosubtotal
            label
            archived
            section(id:$id) {
                id
                breakdown {
                  id
                  total
                }
                total
            }
            templateEntries {
              id
              name
              value
              entrytype
              discount
              archived
              includedByDefault
              entry(id:$id) {
                id    
                btentryid
                value
                fundviewid
                valueFormatted
                accounted
                fundview  
                secondary{
                  id
                  body
                }         
              }
            }
          }
        }
      }
  }`